import styled from 'styled-components'

import { fontSize, fontWeight } from 'src/styles/fonts'
import { color } from 'src/styles'

export const EmptyResultWrap = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const IconWrap = styled.div`
  margin-bottom: 2.4rem;
`

export const Title = styled.h3`
  font-size: ${fontSize.LARGE_XL};
  font-weight: ${fontWeight.EXTRA};
  color: ${color.GREYISH_BROWN};
  margin: 0 0 0.8rem;
`

export const BodyText = styled.p`
  color: ${color.WARM_GREY};
  margin: 0;
`
